<div (click)="showIntro()" class="swing-in-top-fwd">
  <p style="color: var(--ion-color-light);margin: 0;">
    <ion-icon slot="end" name="log-in"></ion-icon>
    {{'LOGIN_BANNER_COMPONENT.LOGIN_TO_SAVE_PROGRESS' | translate}}
  </p>
</div>